var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "alert_message" } },
    [
      _c(
        "v-expansion-panels",
        {
          staticClass: "panel",
          attrs: { accordion: "", tile: "" },
          model: {
            value: _vm.activePanels,
            callback: function($$v) {
              _vm.activePanels = $$v
            },
            expression: "activePanels"
          }
        },
        _vm._l(_vm.alert_messages, function(alert_message, index) {
          return _c(
            "v-expansion-panel",
            { key: index },
            [
              _c(
                "v-expansion-panel-header",
                { staticClass: "panel-header", attrs: { "hide-actions": "" } },
                [
                  _c(
                    "div",
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v(
                          " \n                        " +
                            _vm._s(
                              _vm.activePanels == index
                                ? "icon-arrow-drop-down"
                                : "icon-arrow-drop-right"
                            ) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "font",
                        {
                          staticClass: "panel-header__title",
                          attrs: { color: "white" }
                        },
                        [
                          _vm._v(
                            " \n                        " +
                              _vm._s(alert_message.panel_title) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                { staticClass: "panel-content" },
                [
                  alert_message.contents
                    ? _vm._l(alert_message.contents, function(
                        content,
                        content_index
                      ) {
                        return _c(
                          "div",
                          { key: "content_" + content_index },
                          _vm._l(content.section, function(
                            _section,
                            _section_index
                          ) {
                            return _c(
                              "div",
                              {
                                key: "section" + _section_index,
                                staticClass: "panel-content__container"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "panel-content__title" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_section.h2) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _section.side
                                  ? _c(
                                      "div",
                                      { staticClass: "panel-content__divide" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "panel-content__divide--left"
                                          },
                                          _vm._l(_section.paragraph, function(
                                            _paragraph,
                                            _paragraph_index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key:
                                                  "paragraph" +
                                                  _paragraph_index,
                                                staticClass:
                                                  "panel-content__font"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "panel-content__subtitle"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(_paragraph.h3) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _paragraph.words
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          }),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "panel-content--right"
                                          },
                                          _vm._l(_section.side, function(
                                            item,
                                            item_index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: "item_" + item_index,
                                                staticClass:
                                                  "panel-content__detail"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "panel-content__all" },
                                      _vm._l(_section.paragraph, function(
                                        _paragraph,
                                        _paragraph_index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: "paragraph" + _paragraph_index,
                                            staticClass: "panel-content__font"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "panel-content__subtitle"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(_paragraph.h3) +
                                                    "\n                                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _paragraph.words
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      }),
                                      0
                                    )
                              ]
                            )
                          }),
                          0
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }